const stateRateStatus = {
    INVALID : 0,

    TENTATIVELY_APPROVED : 1,

    APPROVED : 2,

    PENDING_ASSESSMENT_APPROVAL : 3

};

angular.module('gw-um-j2js')
    .constant('stateRateStatus', stateRateStatus);